import { TypographyV3 } from '@jouzen/ecom-components';
import type { ReactNode } from 'react';

import RichText from '@/app/components/RichText';

import QuoteSlider from './QuoteSlider';

const tValues = {
  i: (chunks: ReactNode) => <em className="font-serif italic">{chunks}</em>,
};

const GiftTestimonials = () => {
  return (
    <section className="bg-sandstone-100 py-32">
      <TypographyV3 align="center" className="mb-16" variant="h2" Element="h3">
        <RichText
          messageKey="pdp_horizon_quote_slider_title"
          tValues={tValues}
        />
      </TypographyV3>
      <QuoteSlider />
    </section>
  );
};

export default GiftTestimonials;
